<template>
    <div class="hubspot-form" :id="formDomId"/>
</template>

<script>
    import cmsPlugin from 'vue/mixins/cms/cms-plugin';

    export default {
        mixins: [
            cmsPlugin,
        ],
        computed: {
            formDomId() {
                return `form-${ this.content.form_id }`;
            },
        },

        mounted() {
            window.hbspt.forms.create({
                region: 'eu1',
                portalId: this.content.portal_id,
                formId: this.content.form_id,
                target: `#${ this.formDomId }`,
            });
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?2109b0ea